/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AppReferralsIndexImport } from './routes/_app/referrals/index'
import { Route as AppCallsIndexImport } from './routes/_app/calls/index'
import { Route as AppBuyersIndexImport } from './routes/_app/buyers/index'
import { Route as AppAgentsIndexImport } from './routes/_app/agents/index'
import { Route as AppAgentsAgentIdIndexImport } from './routes/_app/agents/$agentId/index'
import { Route as AppBuyersBuyerIdBuyerLayoutImport } from './routes/_app/buyers/$buyerId/_buyerLayout'
import { Route as AppBuyersBuyerIdBuyerLayoutIndexImport } from './routes/_app/buyers/$buyerId/_buyerLayout/index'
import { Route as AppBuyersBuyerIdBuyerLayoutToolsImport } from './routes/_app/buyers/$buyerId/_buyerLayout/tools'
import { Route as AppBuyersBuyerIdBuyerLayoutMortgageImport } from './routes/_app/buyers/$buyerId/_buyerLayout/mortgage'
import { Route as AppBuyersBuyerIdBuyerLayoutDocumentsImport } from './routes/_app/buyers/$buyerId/_buyerLayout/documents'
import { Route as AppBuyersBuyerIdBuyerLayoutCallsIndexImport } from './routes/_app/buyers/$buyerId/_buyerLayout/calls/index'
import { Route as AppBuyersBuyerIdBuyerLayoutCallsCallIdImport } from './routes/_app/buyers/$buyerId/_buyerLayout/calls/$callId'

// Create Virtual Routes

const AppBuyersBuyerIdImport = createFileRoute('/_app/buyers/$buyerId')()

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppBuyersBuyerIdRoute = AppBuyersBuyerIdImport.update({
  id: '/buyers/$buyerId',
  path: '/buyers/$buyerId',
  getParentRoute: () => AppRoute,
} as any)

const AppReferralsIndexRoute = AppReferralsIndexImport.update({
  id: '/referrals/',
  path: '/referrals/',
  getParentRoute: () => AppRoute,
} as any)

const AppCallsIndexRoute = AppCallsIndexImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AppRoute,
} as any)

const AppBuyersIndexRoute = AppBuyersIndexImport.update({
  id: '/buyers/',
  path: '/buyers/',
  getParentRoute: () => AppRoute,
} as any)

const AppAgentsIndexRoute = AppAgentsIndexImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)

const AppAgentsAgentIdIndexRoute = AppAgentsAgentIdIndexImport.update({
  id: '/agents/$agentId/',
  path: '/agents/$agentId/',
  getParentRoute: () => AppRoute,
} as any)

const AppBuyersBuyerIdBuyerLayoutRoute =
  AppBuyersBuyerIdBuyerLayoutImport.update({
    id: '/_buyerLayout',
    getParentRoute: () => AppBuyersBuyerIdRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutIndexRoute =
  AppBuyersBuyerIdBuyerLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutToolsRoute =
  AppBuyersBuyerIdBuyerLayoutToolsImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutMortgageRoute =
  AppBuyersBuyerIdBuyerLayoutMortgageImport.update({
    id: '/mortgage',
    path: '/mortgage',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutDocumentsRoute =
  AppBuyersBuyerIdBuyerLayoutDocumentsImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutCallsIndexRoute =
  AppBuyersBuyerIdBuyerLayoutCallsIndexImport.update({
    id: '/calls/',
    path: '/calls/',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

const AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute =
  AppBuyersBuyerIdBuyerLayoutCallsCallIdImport.update({
    id: '/calls/$callId',
    path: '/calls/$callId',
    getParentRoute: () => AppBuyersBuyerIdBuyerLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppAgentsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/buyers/': {
      id: '/_app/buyers/'
      path: '/buyers'
      fullPath: '/buyers'
      preLoaderRoute: typeof AppBuyersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/calls/': {
      id: '/_app/calls/'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof AppCallsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/referrals/': {
      id: '/_app/referrals/'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppReferralsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/buyers/$buyerId': {
      id: '/_app/buyers/$buyerId'
      path: '/buyers/$buyerId'
      fullPath: '/buyers/$buyerId'
      preLoaderRoute: typeof AppBuyersBuyerIdImport
      parentRoute: typeof AppImport
    }
    '/_app/buyers/$buyerId/_buyerLayout': {
      id: '/_app/buyers/$buyerId/_buyerLayout'
      path: '/buyers/$buyerId'
      fullPath: '/buyers/$buyerId'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
      parentRoute: typeof AppBuyersBuyerIdRoute
    }
    '/_app/agents/$agentId/': {
      id: '/_app/agents/$agentId/'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AppAgentsAgentIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/documents': {
      id: '/_app/buyers/$buyerId/_buyerLayout/documents'
      path: '/documents'
      fullPath: '/buyers/$buyerId/documents'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutDocumentsImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/mortgage': {
      id: '/_app/buyers/$buyerId/_buyerLayout/mortgage'
      path: '/mortgage'
      fullPath: '/buyers/$buyerId/mortgage'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutMortgageImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/tools': {
      id: '/_app/buyers/$buyerId/_buyerLayout/tools'
      path: '/tools'
      fullPath: '/buyers/$buyerId/tools'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutToolsImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/': {
      id: '/_app/buyers/$buyerId/_buyerLayout/'
      path: '/'
      fullPath: '/buyers/$buyerId/'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutIndexImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/calls/$callId': {
      id: '/_app/buyers/$buyerId/_buyerLayout/calls/$callId'
      path: '/calls/$callId'
      fullPath: '/buyers/$buyerId/calls/$callId'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutCallsCallIdImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
    '/_app/buyers/$buyerId/_buyerLayout/calls/': {
      id: '/_app/buyers/$buyerId/_buyerLayout/calls/'
      path: '/calls'
      fullPath: '/buyers/$buyerId/calls'
      preLoaderRoute: typeof AppBuyersBuyerIdBuyerLayoutCallsIndexImport
      parentRoute: typeof AppBuyersBuyerIdBuyerLayoutImport
    }
  }
}

// Create and export the route tree

interface AppBuyersBuyerIdBuyerLayoutRouteChildren {
  AppBuyersBuyerIdBuyerLayoutDocumentsRoute: typeof AppBuyersBuyerIdBuyerLayoutDocumentsRoute
  AppBuyersBuyerIdBuyerLayoutMortgageRoute: typeof AppBuyersBuyerIdBuyerLayoutMortgageRoute
  AppBuyersBuyerIdBuyerLayoutToolsRoute: typeof AppBuyersBuyerIdBuyerLayoutToolsRoute
  AppBuyersBuyerIdBuyerLayoutIndexRoute: typeof AppBuyersBuyerIdBuyerLayoutIndexRoute
  AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute: typeof AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute
  AppBuyersBuyerIdBuyerLayoutCallsIndexRoute: typeof AppBuyersBuyerIdBuyerLayoutCallsIndexRoute
}

const AppBuyersBuyerIdBuyerLayoutRouteChildren: AppBuyersBuyerIdBuyerLayoutRouteChildren =
  {
    AppBuyersBuyerIdBuyerLayoutDocumentsRoute:
      AppBuyersBuyerIdBuyerLayoutDocumentsRoute,
    AppBuyersBuyerIdBuyerLayoutMortgageRoute:
      AppBuyersBuyerIdBuyerLayoutMortgageRoute,
    AppBuyersBuyerIdBuyerLayoutToolsRoute:
      AppBuyersBuyerIdBuyerLayoutToolsRoute,
    AppBuyersBuyerIdBuyerLayoutIndexRoute:
      AppBuyersBuyerIdBuyerLayoutIndexRoute,
    AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute:
      AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute,
    AppBuyersBuyerIdBuyerLayoutCallsIndexRoute:
      AppBuyersBuyerIdBuyerLayoutCallsIndexRoute,
  }

const AppBuyersBuyerIdBuyerLayoutRouteWithChildren =
  AppBuyersBuyerIdBuyerLayoutRoute._addFileChildren(
    AppBuyersBuyerIdBuyerLayoutRouteChildren,
  )

interface AppBuyersBuyerIdRouteChildren {
  AppBuyersBuyerIdBuyerLayoutRoute: typeof AppBuyersBuyerIdBuyerLayoutRouteWithChildren
}

const AppBuyersBuyerIdRouteChildren: AppBuyersBuyerIdRouteChildren = {
  AppBuyersBuyerIdBuyerLayoutRoute:
    AppBuyersBuyerIdBuyerLayoutRouteWithChildren,
}

const AppBuyersBuyerIdRouteWithChildren =
  AppBuyersBuyerIdRoute._addFileChildren(AppBuyersBuyerIdRouteChildren)

interface AppRouteChildren {
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
  AppBuyersIndexRoute: typeof AppBuyersIndexRoute
  AppCallsIndexRoute: typeof AppCallsIndexRoute
  AppReferralsIndexRoute: typeof AppReferralsIndexRoute
  AppBuyersBuyerIdRoute: typeof AppBuyersBuyerIdRouteWithChildren
  AppAgentsAgentIdIndexRoute: typeof AppAgentsAgentIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgentsIndexRoute: AppAgentsIndexRoute,
  AppBuyersIndexRoute: AppBuyersIndexRoute,
  AppCallsIndexRoute: AppCallsIndexRoute,
  AppReferralsIndexRoute: AppReferralsIndexRoute,
  AppBuyersBuyerIdRoute: AppBuyersBuyerIdRouteWithChildren,
  AppAgentsAgentIdIndexRoute: AppAgentsAgentIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/agents': typeof AppAgentsIndexRoute
  '/buyers': typeof AppBuyersIndexRoute
  '/calls': typeof AppCallsIndexRoute
  '/referrals': typeof AppReferralsIndexRoute
  '/buyers/$buyerId': typeof AppBuyersBuyerIdBuyerLayoutRouteWithChildren
  '/agents/$agentId': typeof AppAgentsAgentIdIndexRoute
  '/buyers/$buyerId/documents': typeof AppBuyersBuyerIdBuyerLayoutDocumentsRoute
  '/buyers/$buyerId/mortgage': typeof AppBuyersBuyerIdBuyerLayoutMortgageRoute
  '/buyers/$buyerId/tools': typeof AppBuyersBuyerIdBuyerLayoutToolsRoute
  '/buyers/$buyerId/': typeof AppBuyersBuyerIdBuyerLayoutIndexRoute
  '/buyers/$buyerId/calls/$callId': typeof AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute
  '/buyers/$buyerId/calls': typeof AppBuyersBuyerIdBuyerLayoutCallsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/agents': typeof AppAgentsIndexRoute
  '/buyers': typeof AppBuyersIndexRoute
  '/calls': typeof AppCallsIndexRoute
  '/referrals': typeof AppReferralsIndexRoute
  '/buyers/$buyerId': typeof AppBuyersBuyerIdBuyerLayoutIndexRoute
  '/agents/$agentId': typeof AppAgentsAgentIdIndexRoute
  '/buyers/$buyerId/documents': typeof AppBuyersBuyerIdBuyerLayoutDocumentsRoute
  '/buyers/$buyerId/mortgage': typeof AppBuyersBuyerIdBuyerLayoutMortgageRoute
  '/buyers/$buyerId/tools': typeof AppBuyersBuyerIdBuyerLayoutToolsRoute
  '/buyers/$buyerId/calls/$callId': typeof AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute
  '/buyers/$buyerId/calls': typeof AppBuyersBuyerIdBuyerLayoutCallsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/buyers/': typeof AppBuyersIndexRoute
  '/_app/calls/': typeof AppCallsIndexRoute
  '/_app/referrals/': typeof AppReferralsIndexRoute
  '/_app/buyers/$buyerId': typeof AppBuyersBuyerIdRouteWithChildren
  '/_app/buyers/$buyerId/_buyerLayout': typeof AppBuyersBuyerIdBuyerLayoutRouteWithChildren
  '/_app/agents/$agentId/': typeof AppAgentsAgentIdIndexRoute
  '/_app/buyers/$buyerId/_buyerLayout/documents': typeof AppBuyersBuyerIdBuyerLayoutDocumentsRoute
  '/_app/buyers/$buyerId/_buyerLayout/mortgage': typeof AppBuyersBuyerIdBuyerLayoutMortgageRoute
  '/_app/buyers/$buyerId/_buyerLayout/tools': typeof AppBuyersBuyerIdBuyerLayoutToolsRoute
  '/_app/buyers/$buyerId/_buyerLayout/': typeof AppBuyersBuyerIdBuyerLayoutIndexRoute
  '/_app/buyers/$buyerId/_buyerLayout/calls/$callId': typeof AppBuyersBuyerIdBuyerLayoutCallsCallIdRoute
  '/_app/buyers/$buyerId/_buyerLayout/calls/': typeof AppBuyersBuyerIdBuyerLayoutCallsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/agents'
    | '/buyers'
    | '/calls'
    | '/referrals'
    | '/buyers/$buyerId'
    | '/agents/$agentId'
    | '/buyers/$buyerId/documents'
    | '/buyers/$buyerId/mortgage'
    | '/buyers/$buyerId/tools'
    | '/buyers/$buyerId/'
    | '/buyers/$buyerId/calls/$callId'
    | '/buyers/$buyerId/calls'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/login'
    | '/agents'
    | '/buyers'
    | '/calls'
    | '/referrals'
    | '/buyers/$buyerId'
    | '/agents/$agentId'
    | '/buyers/$buyerId/documents'
    | '/buyers/$buyerId/mortgage'
    | '/buyers/$buyerId/tools'
    | '/buyers/$buyerId/calls/$callId'
    | '/buyers/$buyerId/calls'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/agents/'
    | '/_app/buyers/'
    | '/_app/calls/'
    | '/_app/referrals/'
    | '/_app/buyers/$buyerId'
    | '/_app/buyers/$buyerId/_buyerLayout'
    | '/_app/agents/$agentId/'
    | '/_app/buyers/$buyerId/_buyerLayout/documents'
    | '/_app/buyers/$buyerId/_buyerLayout/mortgage'
    | '/_app/buyers/$buyerId/_buyerLayout/tools'
    | '/_app/buyers/$buyerId/_buyerLayout/'
    | '/_app/buyers/$buyerId/_buyerLayout/calls/$callId'
    | '/_app/buyers/$buyerId/_buyerLayout/calls/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/agents/",
        "/_app/buyers/",
        "/_app/calls/",
        "/_app/referrals/",
        "/_app/buyers/$buyerId",
        "/_app/agents/$agentId/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_app/agents/": {
      "filePath": "_app/agents/index.tsx",
      "parent": "/_app"
    },
    "/_app/buyers/": {
      "filePath": "_app/buyers/index.tsx",
      "parent": "/_app"
    },
    "/_app/calls/": {
      "filePath": "_app/calls/index.tsx",
      "parent": "/_app"
    },
    "/_app/referrals/": {
      "filePath": "_app/referrals/index.tsx",
      "parent": "/_app"
    },
    "/_app/buyers/$buyerId": {
      "filePath": "_app/buyers/$buyerId",
      "parent": "/_app",
      "children": [
        "/_app/buyers/$buyerId/_buyerLayout"
      ]
    },
    "/_app/buyers/$buyerId/_buyerLayout": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout.tsx",
      "parent": "/_app/buyers/$buyerId",
      "children": [
        "/_app/buyers/$buyerId/_buyerLayout/documents",
        "/_app/buyers/$buyerId/_buyerLayout/mortgage",
        "/_app/buyers/$buyerId/_buyerLayout/tools",
        "/_app/buyers/$buyerId/_buyerLayout/",
        "/_app/buyers/$buyerId/_buyerLayout/calls/$callId",
        "/_app/buyers/$buyerId/_buyerLayout/calls/"
      ]
    },
    "/_app/agents/$agentId/": {
      "filePath": "_app/agents/$agentId/index.tsx",
      "parent": "/_app"
    },
    "/_app/buyers/$buyerId/_buyerLayout/documents": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/documents.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    },
    "/_app/buyers/$buyerId/_buyerLayout/mortgage": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/mortgage.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    },
    "/_app/buyers/$buyerId/_buyerLayout/tools": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/tools.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    },
    "/_app/buyers/$buyerId/_buyerLayout/": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/index.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    },
    "/_app/buyers/$buyerId/_buyerLayout/calls/$callId": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/calls/$callId.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    },
    "/_app/buyers/$buyerId/_buyerLayout/calls/": {
      "filePath": "_app/buyers/$buyerId/_buyerLayout/calls/index.tsx",
      "parent": "/_app/buyers/$buyerId/_buyerLayout"
    }
  }
}
ROUTE_MANIFEST_END */
